import { SET_USER_INFO, SET_USER_THEME } from "../types/User";

export const setUserTheme = (payload: string) => ({
    type: SET_USER_THEME,
    payload,
})

export const setUserInfo = (payload: Object) => ({
    type: SET_USER_INFO,
    payload,
})